var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ElementRef, ViewContainerRef, ChangeDetectionStrategy, Renderer2, Injector, ContentChild } from '@angular/core';
import { ComponentBase, ComponentMixins, setValue } from '@syncfusion/ej2-angular-base';
import { Schedule } from '@syncfusion/ej2-schedule';
import { Template } from '@syncfusion/ej2-angular-base';
import { ViewsDirective } from './views.directive';
import { ResourcesDirective } from './resources.directive';
import { HeaderRowsDirective } from './headerrows.directive';
export var inputs = ['agendaDaysCount', 'allowDragAndDrop', 'allowKeyboardInteraction', 'allowResizing', 'cellTemplate', 'cssClass', 'currentView', 'dateFormat', 'dateHeaderTemplate', 'editorTemplate', 'enablePersistence', 'enableRtl', 'endHour', 'eventDragArea', 'eventSettings', 'firstDayOfWeek', 'group', 'headerRows', 'height', 'hideEmptyAgendaDays', 'locale', 'quickInfoTemplates', 'readonly', 'resourceHeaderTemplate', 'resources', 'selectedDate', 'showHeaderBar', 'showQuickInfo', 'showTimeIndicator', 'showWeekNumber', 'showWeekend', 'startHour', 'timeScale', 'timezone', 'views', 'width', 'workDays', 'workHours'];
export var outputs = ['actionBegin', 'actionComplete', 'actionFailure', 'cellClick', 'cellDoubleClick', 'created', 'dataBinding', 'dataBound', 'destroyed', 'drag', 'dragStart', 'dragStop', 'eventClick', 'eventRendered', 'navigating', 'popupOpen', 'renderCell', 'resizeStart', 'resizeStop', 'resizing', 'currentViewChange', 'selectedDateChange'];
export var twoWays = ['currentView', 'selectedDate'];
/**
 * `ej-schedule` represents the Angular Schedule Component.
 * ```html
 * <ejs-schedule></ejs-schedule>
 * ```
 */
var ScheduleComponent = /** @class */ (function (_super) {
    __extends(ScheduleComponent, _super);
    function ScheduleComponent(ngEle, srenderer, viewContainerRef, injector) {
        var _this = _super.call(this) || this;
        _this.ngEle = ngEle;
        _this.srenderer = srenderer;
        _this.viewContainerRef = viewContainerRef;
        _this.injector = injector;
        _this.tags = ['views', 'resources', 'headerRows'];
        _this.element = _this.ngEle.nativeElement;
        _this.injectedModules = _this.injectedModules || [];
        try {
            _this.injectedModules.push(_this.injector.get('ScheduleDay'));
        }
        catch (_a) { }
        try {
            _this.injectedModules.push(_this.injector.get('ScheduleWeek'));
        }
        catch (_b) { }
        try {
            _this.injectedModules.push(_this.injector.get('ScheduleWorkWeek'));
        }
        catch (_c) { }
        try {
            _this.injectedModules.push(_this.injector.get('ScheduleMonth'));
        }
        catch (_d) { }
        try {
            _this.injectedModules.push(_this.injector.get('ScheduleAgenda'));
        }
        catch (_e) { }
        try {
            _this.injectedModules.push(_this.injector.get('ScheduleMonthAgenda'));
        }
        catch (_f) { }
        try {
            _this.injectedModules.push(_this.injector.get('ScheduleTimelineViews'));
        }
        catch (_g) { }
        try {
            _this.injectedModules.push(_this.injector.get('ScheduleTimelineMonth'));
        }
        catch (_h) { }
        try {
            _this.injectedModules.push(_this.injector.get('ScheduleResize'));
        }
        catch (_j) { }
        try {
            _this.injectedModules.push(_this.injector.get('ScheduleDragAndDrop'));
        }
        catch (_k) { }
        _this.registerEvents(outputs);
        _this.addTwoWay.call(_this, twoWays);
        setValue('currentInstance', _this, _this.viewContainerRef);
        return _this;
    }
    ScheduleComponent.prototype.ngOnInit = function () {
    };
    ScheduleComponent.prototype.ngAfterViewInit = function () {
    };
    ScheduleComponent.prototype.ngOnDestroy = function () {
    };
    ScheduleComponent.prototype.ngAfterContentChecked = function () {
    };
    ScheduleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ejs-schedule',
                    inputs: inputs,
                    outputs: outputs,
                    template: '',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    queries: {
                        childViews: new ContentChild(ViewsDirective),
                        childResources: new ContentChild(ResourcesDirective),
                        childHeaderRows: new ContentChild(HeaderRowsDirective)
                    }
                },] },
    ];
    /** @nocollapse */
    ScheduleComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
        { type: ViewContainerRef, },
        { type: Injector, },
    ]; };
    ScheduleComponent.propDecorators = {
        'dateHeaderTemplate': [{ type: ContentChild, args: ['dateHeaderTemplate',] },],
        'cellTemplate': [{ type: ContentChild, args: ['cellTemplate',] },],
        'eventSettings_tooltipTemplate': [{ type: ContentChild, args: ['eventSettingsTooltipTemplate',] },],
        'eventSettings_template': [{ type: ContentChild, args: ['eventSettingsTemplate',] },],
        'editorTemplate': [{ type: ContentChild, args: ['editorTemplate',] },],
        'timeScale_minorSlotTemplate': [{ type: ContentChild, args: ['timeScaleMinorSlotTemplate',] },],
        'timeScale_majorSlotTemplate': [{ type: ContentChild, args: ['timeScaleMajorSlotTemplate',] },],
        'resourceHeaderTemplate': [{ type: ContentChild, args: ['resourceHeaderTemplate',] },],
        'quickInfoTemplates_header': [{ type: ContentChild, args: ['quickInfoTemplatesHeader',] },],
        'quickInfoTemplates_content': [{ type: ContentChild, args: ['quickInfoTemplatesContent',] },],
        'quickInfoTemplates_footer': [{ type: ContentChild, args: ['quickInfoTemplatesFooter',] },],
        'group_headerTooltipTemplate': [{ type: ContentChild, args: ['groupHeaderTooltipTemplate',] },],
    };
    __decorate([
        Template(),
        __metadata("design:type", Object)
    ], ScheduleComponent.prototype, "dateHeaderTemplate", void 0);
    __decorate([
        Template(),
        __metadata("design:type", Object)
    ], ScheduleComponent.prototype, "cellTemplate", void 0);
    __decorate([
        Template(),
        __metadata("design:type", Object)
    ], ScheduleComponent.prototype, "eventSettings_tooltipTemplate", void 0);
    __decorate([
        Template(),
        __metadata("design:type", Object)
    ], ScheduleComponent.prototype, "eventSettings_template", void 0);
    __decorate([
        Template(),
        __metadata("design:type", Object)
    ], ScheduleComponent.prototype, "editorTemplate", void 0);
    __decorate([
        Template(),
        __metadata("design:type", Object)
    ], ScheduleComponent.prototype, "timeScale_minorSlotTemplate", void 0);
    __decorate([
        Template(),
        __metadata("design:type", Object)
    ], ScheduleComponent.prototype, "timeScale_majorSlotTemplate", void 0);
    __decorate([
        Template(),
        __metadata("design:type", Object)
    ], ScheduleComponent.prototype, "resourceHeaderTemplate", void 0);
    __decorate([
        Template(),
        __metadata("design:type", Object)
    ], ScheduleComponent.prototype, "quickInfoTemplates_header", void 0);
    __decorate([
        Template(),
        __metadata("design:type", Object)
    ], ScheduleComponent.prototype, "quickInfoTemplates_content", void 0);
    __decorate([
        Template(),
        __metadata("design:type", Object)
    ], ScheduleComponent.prototype, "quickInfoTemplates_footer", void 0);
    __decorate([
        Template(),
        __metadata("design:type", Object)
    ], ScheduleComponent.prototype, "group_headerTooltipTemplate", void 0);
    ScheduleComponent = __decorate([
        ComponentMixins([ComponentBase]),
        __metadata("design:paramtypes", [ElementRef, Renderer2, ViewContainerRef, Injector])
    ], ScheduleComponent);
    return ScheduleComponent;
}(Schedule));
export { ScheduleComponent };
//# sourceMappingURL=schedule.component.js.map